// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"> <path fill=\"#4A4A4A\" fill-rule=\"evenodd\" d=\"M16 0v16H0V0h16zm-2 2H2v12h12V2zM9 4v5H4V4h5z\"/> </svg> ";
// Exports
module.exports = code;